import { EMPTY_ARRAY } from 'utils/immutable';

export const getCustomSteps = state =>
  state.flowDesigner.customSteps ?? EMPTY_ARRAY;
